import { useParams } from "react-router-dom";

import { Row } from "react-bootstrap";

import { TabsWithRoute } from "@/components/TabsWithRoute";

export function ReportCardAndHistoricTabs() {
	const { id } = useParams();

	return (
		<Row className="ms-1">
			<ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap">
				<TabsWithRoute name="Boletim de AIH" route={`/informacoes-aih/boletim/${id}`} />

				<TabsWithRoute name="Histórico de AIH" route={`/informacoes-aih/historico/${id}`} />
			</ul>
		</Row>
	);
}
